'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconArrowUpRectangle, iconArrowUpRectangleTag } from '@ni/nimble-components/dist/esm/icons/arrow-up-rectangle';
import { wrap } from '../../utilities/react-wrapper';

export type { IconArrowUpRectangle };
export { iconArrowUpRectangleTag };
export const NimbleIconArrowUpRectangle = wrap(IconArrowUpRectangle);